
import { Vue, Prop, Component } from "vue-property-decorator"
import { Approval } from "@/gql"

@Component
export default class ApprovalStateCard extends Vue {
  @Prop({ required: true })
  approval!: Approval[]
}
